import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./OverviewCard.module.css";

interface Props {
  index: number;
  title: string;
  text: string;
  isClickable?: boolean;
  onClick?: () => void;
}

const OverviewCard: React.FC<Props> = ({
  index,
  title,
  text,
  isClickable,
  onClick,
}) => {
  return (
    <div
      className={toClassName(styles.container, {
        [styles.containerHover]: isClickable,
      })}
      onClick={isClickable && onClick ? () => onClick() : undefined}
    >
      <Text variant={"title1"}>{index}</Text>

      <div className={styles.bottom}>
        <Text variant={"title2"}>{title}</Text>

        <Text variant="body" color={"textSubtle"}>
          {text}
        </Text>
      </div>
    </div>
  );
};

export default OverviewCard;
